import React from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import HeaderCarouselBlockData from 'Models/Content/HeaderCarouselBlockData';
import HeaderCarouselItemData from 'Models/Content/HeaderCarouselItemData';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';

import HeaderCarousel, {HeaderCarouselItem} from './HeaderCarousel';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';

const HeaderCarouselBlock = ({data, context}: ComponentProps<HeaderCarouselBlockData>) => {
  const items: HeaderCarouselItem[] = data.headerCarouselItem.expandedValue.map((item: HeaderCarouselItemData) => {
    const titleHeadlineTag = item.titleHeadlineTag?.value ? item.titleHeadlineTag.value : 2;
    const subtitleHeadlineTag = item.subtitleHeadlineTag?.value ? item.subtitleHeadlineTag?.value : 7;
    const textBlock = item.title.expandedValue[0] as MarketingTextBlockData;
    const text =
      !isMobile && item.desktopTitle.expandedValue
        ? (item.desktopTitle.expandedValue[0] as MarketingTextBlockData).text.value
        : textBlock.text.value;
    const subtitle = !isMobile && item.desktopSubtitle?.value ? item.desktopSubtitle.value : item.subtitle.value;
    const highlightText = textBlock.highlightText.value;
    const imageDesktop = getBackgroundImageProps(item?.image, context);
    const imageMobile = getBackgroundImageProps(item?.mobileImage, context);
    const videoMobile = item.mobileVideo?.expandedValue?.url ? context.getEpiserverUrl(item.mobileVideo.expandedValue.url) : null;
    const videoDesktop = item.video?.expandedValue?.url ? context.getEpiserverUrl(item.video.expandedValue.url) : null;
    const buttonLink = item.buttonLink?.value ? item.buttonLink.value : null;
    const buttonLinkTitle = item.buttonLinkTitle?.value ?? '';
    const blockButton = item.blockButton?.expandedValue;

    return {
      imageDesktop,
      imageMobile,
      videoMobile,
      videoDesktop,
      text,
      subtitle,
      highlightText,
      buttonLink,
      buttonLinkTitle,
      titleHeadlineTag,
      subtitleHeadlineTag,
      blockButton

    };
  });

  return <HeaderCarousel items={items} />;
};

export default HeaderCarouselBlock;
